export const SUPPLIERS_STORE = 'SUPPLIERS_STORE';
export const SUPPLIERTYPES_STORE = 'SUPPLIERTYPES_STORE';
export const PURCHASEORDERS_STORE = 'PURCHASEORDERS_STORE';
export const PRODUCTGROUPS_STORE = 'PRODUCTGROUPS_STORE';
export const PRODUCTS_STORE = 'PRODUCTS_STORE';
export const UNITOFMEASUREMENTS_STORE = 'UNITOFMEASUREMENTS_STORE';
export const PURCHASEORDERTYPES_STORE = 'PURCHASEORDERTYPES_STORE';
export const PAYMENTTERMS_STORE = 'PAYMENTTERMS_STORE';
export const TRANSPORTTYPES_STORE = 'TRANSPORTTYPES_STORE';
export const CURRENCIES_STORE = 'CURRENCIES_STORE';
export const LANGUAGES_STORE = 'LANGUAGES_STORE';
export const TRANSLATIONVALUES_STORE = 'TRANSLATIONVALUES_STORE';
export const TRANSLATIONS_STORE = 'TRANSLATIONS_STORE';
export const TRANSLATIONTYPES_STORE = 'TRANSLATIONTYPES_STORE';
export const SYSTEMTRANSLATIONS_STORE = 'SYSTEMTRANSLATIONS_STORE';
export const SYSTEMTRANSLATIONVALUES_STORE = 'SYSTEMTRANSLATIONVALUES_STORE';
export const SYSTEMPARAMETERS_STORE = 'SYSTEMPARAMETERS_STORE';
export const SYSTEMPARAMETERVALUES_STORE = 'SYSTEMPARAMETERVALUES_STORE';
export const COUNTRIES_STORE = 'COUNTRIES_STORE';
export const NUMBERRANGES_STORE = 'NUMBERRANGES_STORE';
export const DOCUMENTTEXTOVERVIEW_STORE = 'DOCUMENTTEXTOVERVIEW_STORE';
export const BROKERS_STORE = 'BROKERS_STORE';
export const DOCUMENTS_STORE = 'DOCUMENTS_STORE';
export const DOCUMENTTYPES_STORE = 'DOCUMENTTYPES_STORE';
export const PURCHASEORDERDOCUMENTS_STORE = 'PURCHASEORDERDOCUMENTS_STORE';
export const UPDATEPURCHASEORDER = 'UPDATEPURCHASEORDER';
export const PRICESCHEMES_STORE = 'PRICESCHEMES_STORE';
export const FREECLAUSES_STORE = 'FREECLAUSES_STORE';